import { useMediaQuery } from "react-responsive";

// Modules
import sassVariables from "theme/_breakpoints.module.sass";

const getNumber = (str: string): number => Number(str.replace("px", ""));

type UseBreakpointType = {
  isLargeDesktop: boolean;
  isDesktop: boolean;
  isTabletAndLess: boolean;
  isSmallTablet: boolean;
  isPhone: boolean;
  isSmallPhone: boolean;
  isCustomBreakpointSmaller: boolean | null;
  isCustomBreakpointBigger: boolean | null;
  isPhoneHeight: boolean;
};

export const useBreakpoint = (breakpoint?: number): UseBreakpointType => {
  return {
    isLargeDesktop: useMediaQuery({
      query: `(min-width: ${sassVariables.largeDesktop})`,
    }),
    isDesktop: useMediaQuery({
      query: `(min-width: ${getNumber(sassVariables.tablet) + 1}px)`,
    }),
    isTabletAndLess: useMediaQuery({
      query: `(max-width: ${sassVariables.tablet})`,
    }),
    isSmallTablet: useMediaQuery({
      query: `(max-width: ${sassVariables.smallTablet}) and (min-width: ${getNumber(sassVariables.phone) + 1}px)`,
    }),
    isPhone: useMediaQuery({ query: `(max-width: ${sassVariables.phone})` }),
    isSmallPhone: useMediaQuery({
      query: `(max-width: ${sassVariables.smallPhone})`,
    }),
    isCustomBreakpointSmaller: breakpoint
      ? useMediaQuery({ query: `(max-width: ${breakpoint}px)` })
      : null,
    isCustomBreakpointBigger: breakpoint
      ? useMediaQuery({ query: `(min-width: ${breakpoint + 1}px)` })
      : null,
    isPhoneHeight: useMediaQuery({
      query: `(max-height: ${sassVariables.phone})`,
    }),
  };
};
